import {
  Box,
  Button,
  IconButton,
  Modal,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import { useRouter } from 'next/router';
import CloseIcon from '@mui/icons-material/Close';
import JsCookie from 'js-cookie';
import { DISMISS_ACTIVE_SUBSCRIPTION_MODAL_COOKIE } from '../../utils/constants';

const ActiveSubscriptionInfoModal = (props: {
  secondaryCopy: string;
  email: string;
  closeButtonText: string;
  open: boolean;
  onDismiss: () => void;
}) => {
  const [disableButtons, setDisableButtons] = useState(false);

  const dismiss = () => {
    // This is a session cookie since no expiration is specified
    JsCookie.set(DISMISS_ACTIVE_SUBSCRIPTION_MODAL_COOKIE, 'true');
    props.onDismiss();
    setDisableButtons(true);
  };

  const router = useRouter();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );

  const handleEditMealsClick = () => {
    router.push('/');
    setDisableButtons(true);
  };

  return (
    <Modal
      open={props.open}
      onClose={dismiss}
      sx={{
        ['.MuiBackdrop-root']: {
          backdropFilter: 'blur(4px)',
        },
        boxShadow: 24,
      }}
      css={{
        textAlign: 'center',
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '5.5rem',
        alignItems: 'flex-start',
        height: '100vh',
        width: '100vw',
      }}
    >
      <Box
        css={{
          width: '30rem',
          padding: '1.5rem',
          margin: isSmallScreen ? undefined : '0 auto 2.75rem',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '2px',
          '&:focus-visible': {
            outline: 'none',
          },
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <IconButton
          onClick={dismiss}
          css={{ position: 'absolute', right: 0, top: 0 }}
          disabled={disableButtons}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant={'body1'} sx={{ marginBottom: '1rem' }}>
          There is already an active subscription for {props.email}.
        </Typography>

        <Typography variant={'body1'} sx={{ marginBottom: '1rem' }}>
          {props.secondaryCopy}
        </Typography>

        <Button
          variant={'contained'}
          sx={{ marginBottom: '1rem' }}
          onClick={handleEditMealsClick}
          disabled={disableButtons}
        >
          Edit My Meals
        </Button>
        <Button
          variant={'outlined'}
          onClick={dismiss}
          disabled={disableButtons}
        >
          {props.closeButtonText}
        </Button>
      </Box>
    </Modal>
  );
};

export default ActiveSubscriptionInfoModal;
